// extracted by mini-css-extract-plugin
export default {"logoBar":"appbarTitle_logoBar__0KYDH","header":"appbarTitle_header__DK3AL"};